import { ThemeProvider } from '@volkswagen-onehub/components-core';
import * as React from 'react';
import { NotificationManagerFeatureApp } from './app';
const featureAppDefinition = {
    optionalDependencies: {
        featureServices: {
            'notifications-manager': '^1.0.0',
        },
    },
    create: ({ featureServices }) => {
        const notificationsManager = featureServices['notifications-manager'];
        return {
            render: () => (React.createElement(ThemeProvider, { theme: "main", direction: "ltr" },
                React.createElement(NotificationManagerFeatureApp, { service: notificationsManager }))),
        };
    },
};
export default featureAppDefinition;
//# sourceMappingURL=index.js.map